export const ConsumerNotificationNoteType = 'ext';
export const RegularNoteType = 'int';
